import { render } from "./ViewLiquidationHistory.vue?vue&type=template&id=8822c54e"
import script from "./ViewLiquidationHistory.vue?vue&type=script&lang=js"
export * from "./ViewLiquidationHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__